import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Tenant\NodeExportController::download
* @see app/Http/Controllers/Tenant/NodeExportController.php:22
* @route '/user/nodes/download'
*/
export const download = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/user/nodes/download',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\NodeExportController::download
* @see app/Http/Controllers/Tenant/NodeExportController.php:22
* @route '/user/nodes/download'
*/
download.url = (options?: RouteQueryOptions) => {
    return download.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\NodeExportController::download
* @see app/Http/Controllers/Tenant/NodeExportController.php:22
* @route '/user/nodes/download'
*/
download.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\NodeExportController::download
* @see app/Http/Controllers/Tenant/NodeExportController.php:22
* @route '/user/nodes/download'
*/
download.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeChildrenController.php:14
* @route '/user/{node}/children'
*/
export const children = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: children.url(args, options),
    method: 'get',
})

children.definition = {
    methods: ["get","head"],
    url: '/user/{node}/children',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeChildrenController.php:14
* @route '/user/{node}/children'
*/
children.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return children.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeChildrenController.php:14
* @route '/user/{node}/children'
*/
children.get = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: children.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeChildrenController::__invoke
* @see app/Http/Controllers/Tenant/Branch/NodeChildrenController.php:14
* @route '/user/{node}/children'
*/
children.head = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: children.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\InsertNodeParentController::__invoke
* @see app/Http/Controllers/Tenant/Branch/InsertNodeParentController.php:18
* @route '/user/{node}/insert-parent'
*/
export const insertParent = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: insertParent.url(args, options),
    method: 'post',
})

insertParent.definition = {
    methods: ["post"],
    url: '/user/{node}/insert-parent',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\InsertNodeParentController::__invoke
* @see app/Http/Controllers/Tenant/Branch/InsertNodeParentController.php:18
* @route '/user/{node}/insert-parent'
*/
insertParent.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return insertParent.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\InsertNodeParentController::__invoke
* @see app/Http/Controllers/Tenant/Branch/InsertNodeParentController.php:18
* @route '/user/{node}/insert-parent'
*/
insertParent.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: insertParent.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAddedToPaperAtController::addToPaper
* @see app/Http/Controllers/Tenant/Branch/UpdateAddedToPaperAtController.php:15
* @route '/user/nodes/{node}/add-to-paper'
*/
export const addToPaper = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addToPaper.url(args, options),
    method: 'post',
})

addToPaper.definition = {
    methods: ["post"],
    url: '/user/nodes/{node}/add-to-paper',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAddedToPaperAtController::addToPaper
* @see app/Http/Controllers/Tenant/Branch/UpdateAddedToPaperAtController.php:15
* @route '/user/nodes/{node}/add-to-paper'
*/
addToPaper.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return addToPaper.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAddedToPaperAtController::addToPaper
* @see app/Http/Controllers/Tenant/Branch/UpdateAddedToPaperAtController.php:15
* @route '/user/nodes/{node}/add-to-paper'
*/
addToPaper.post = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addToPaper.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAllAddedToPaperAtController::addAllToPaper
* @see app/Http/Controllers/Tenant/Branch/UpdateAllAddedToPaperAtController.php:17
* @route '/user/nodes/add-to-paper'
*/
export const addAllToPaper = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addAllToPaper.url(options),
    method: 'post',
})

addAllToPaper.definition = {
    methods: ["post"],
    url: '/user/nodes/add-to-paper',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAllAddedToPaperAtController::addAllToPaper
* @see app/Http/Controllers/Tenant/Branch/UpdateAllAddedToPaperAtController.php:17
* @route '/user/nodes/add-to-paper'
*/
addAllToPaper.url = (options?: RouteQueryOptions) => {
    return addAllToPaper.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAllAddedToPaperAtController::addAllToPaper
* @see app/Http/Controllers/Tenant/Branch/UpdateAllAddedToPaperAtController.php:17
* @route '/user/nodes/add-to-paper'
*/
addAllToPaper.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addAllToPaper.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAllFullNameController::__invoke
* @see app/Http/Controllers/Tenant/Branch/UpdateAllFullNameController.php:16
* @route '/user/nodes/update-full-name'
*/
export const updateFullName = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: updateFullName.url(options),
    method: 'post',
})

updateFullName.definition = {
    methods: ["post"],
    url: '/user/nodes/update-full-name',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAllFullNameController::__invoke
* @see app/Http/Controllers/Tenant/Branch/UpdateAllFullNameController.php:16
* @route '/user/nodes/update-full-name'
*/
updateFullName.url = (options?: RouteQueryOptions) => {
    return updateFullName.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateAllFullNameController::__invoke
* @see app/Http/Controllers/Tenant/Branch/UpdateAllFullNameController.php:16
* @route '/user/nodes/update-full-name'
*/
updateFullName.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: updateFullName.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\ResetAllNodesStyleController::__invoke
* @see app/Http/Controllers/Tenant/Branch/ResetAllNodesStyleController.php:18
* @route '/user/nodes/reset-style'
*/
export const resetStyle = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: resetStyle.url(options),
    method: 'put',
})

resetStyle.definition = {
    methods: ["put"],
    url: '/user/nodes/reset-style',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\ResetAllNodesStyleController::__invoke
* @see app/Http/Controllers/Tenant/Branch/ResetAllNodesStyleController.php:18
* @route '/user/nodes/reset-style'
*/
resetStyle.url = (options?: RouteQueryOptions) => {
    return resetStyle.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\ResetAllNodesStyleController::__invoke
* @see app/Http/Controllers/Tenant/Branch/ResetAllNodesStyleController.php:18
* @route '/user/nodes/reset-style'
*/
resetStyle.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: resetStyle.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Tenant\NodeStyleController::__invoke
* @see app/Http/Controllers/Tenant/NodeStyleController.php:15
* @route '/user/nodes/{node}/style'
*/
export const style = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: style.url(args, options),
    method: 'put',
})

style.definition = {
    methods: ["put"],
    url: '/user/nodes/{node}/style',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Tenant\NodeStyleController::__invoke
* @see app/Http/Controllers/Tenant/NodeStyleController.php:15
* @route '/user/nodes/{node}/style'
*/
style.url = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        node: typeof args.node === 'object'
        ? args.node.id
        : args.node,
    }

    return style.definition.url
            .replace('{node}', parsedArgs.node.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\NodeStyleController::__invoke
* @see app/Http/Controllers/Tenant/NodeStyleController.php:15
* @route '/user/nodes/{node}/style'
*/
style.put = (args: { node: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: style.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Tenant\NodeBulkStyleController::__invoke
* @see app/Http/Controllers/Tenant/NodeBulkStyleController.php:15
* @route '/user/nodes/bulk-style'
*/
export const bulkStyle = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: bulkStyle.url(options),
    method: 'put',
})

bulkStyle.definition = {
    methods: ["put"],
    url: '/user/nodes/bulk-style',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Tenant\NodeBulkStyleController::__invoke
* @see app/Http/Controllers/Tenant/NodeBulkStyleController.php:15
* @route '/user/nodes/bulk-style'
*/
bulkStyle.url = (options?: RouteQueryOptions) => {
    return bulkStyle.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\NodeBulkStyleController::__invoke
* @see app/Http/Controllers/Tenant/NodeBulkStyleController.php:15
* @route '/user/nodes/bulk-style'
*/
bulkStyle.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: bulkStyle.url(options),
    method: 'put',
})

const nodes = {
    download: Object.assign(download, download),
    children: Object.assign(children, children),
    insertParent: Object.assign(insertParent, insertParent),
    addToPaper: Object.assign(addToPaper, addToPaper),
    addAllToPaper: Object.assign(addAllToPaper, addAllToPaper),
    updateFullName: Object.assign(updateFullName, updateFullName),
    resetStyle: Object.assign(resetStyle, resetStyle),
    style: Object.assign(style, style),
    bulkStyle: Object.assign(bulkStyle, bulkStyle),
}

export default nodes